var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-1.5 p-1.5"},[_c('VideoLengthIcon',{staticClass:"text-icon-normal flex-shrink-0"}),_c('BaseText',{staticClass:"text-text-muted",attrs:{"type":"label","size":"sm"}},[_vm._v(" Video Length Filter ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }